import React from 'react';

const InjectedPropsContext = React.createContext();

export { InjectedPropsContext };
export default InjectedPropsContext;
